import React from 'react';

export const NoReviewers = () => (
  <section className="step-members">
    No Assigned Reviewers
  </section>
);

export default NoReviewers;
